// extracted by mini-css-extract-plugin
export var breadCrumb = "blog-review-module--breadCrumb--b76c3";
export var card = "blog-review-module--card--5e803";
export var closedSources = "blog-review-module--closedSources--f8fad";
export var contentStyle = "blog-review-module--contentStyle--20063";
export var expandSectionButton = "blog-review-module--expandSectionButton--16c06";
export var expanded = "blog-review-module--expanded--0d1a7";
export var genericContainer = "blog-review-module--genericContainer--975ef";
export var gridContainer = "blog-review-module--gridContainer--a0981";
export var gridContent = "blog-review-module--gridContent--5262d";
export var gridStaticContainer = "blog-review-module--gridStaticContainer--ba3b4";
export var headingTitle = "blog-review-module--headingTitle--7d89e";
export var indexSection = "blog-review-module--indexSection--dde36";
export var intro = "blog-review-module--intro--80749";
export var lastUpdated = "blog-review-module--lastUpdated--b5e85";
export var mainContent = "blog-review-module--mainContent--4705d";
export var openedSources = "blog-review-module--openedSources--49738";
export var sorcesContent = "blog-review-module--sorcesContent--399b5";
export var sourceButton = "blog-review-module--sourceButton--0d57a";
export var sourcesSection = "blog-review-module--sourcesSection--bf753";
export var sourcesTitle = "blog-review-module--sourcesTitle--fd8ad";
export var sourcesTitleIcon = "blog-review-module--sourcesTitleIcon--5f4a9";
export var sponsorCard = "blog-review-module--sponsorCard--5c59a";